function scrollToTop(id) {
  const elmnt = document.getElementById(id);
  elmnt.scrollIntoView();
  // document.body.scrollTop = 0;
  // document.documentElement.scrollTop = 0;
}

export default scrollToTop;
